import { Form, Modal } from 'antd'
import { forwardRef, useImperativeHandle, useState } from 'react'
import FormInput from '@src/pages/notification-template/components/FormInput'
import { useMutationPostAndSendNotificationTemplate } from '@src/queries/hooks'
import { TPostNotificationTemplate } from '@src/modules'

import { TDataNotify } from '../ActionPublish'
import SelectSingleFileFormItem from '../SelectSingleFileFormItem'

export type THandleModalCPNotify = {
  onOpen: (v: boolean) => void
}

export type TModalCPNotify = {
  data: TDataNotify
}

const ModalCPNotify = forwardRef(({ data }: TModalCPNotify, ref) => {
  const [form] = Form.useForm()
  const [isOpen, setIsOpen] = useState(false)

  useImperativeHandle(
    ref,
    () => ({
      onOpen: (x: boolean) => setIsOpen(x),
    }),
    [],
  )

  const onClose = () => {
    setIsOpen(false)
    form.resetFields()
  }

  const { mutate, isLoading } = useMutationPostAndSendNotificationTemplate()

  const onFinish = (values: TPostNotificationTemplate) => {
    mutate(
      {
        ...values,
        data,
      },
      {
        onSuccess: onClose,
      },
    )
  }

  return (
    <Modal
      open={isOpen}
      title="Create & send notification"
      width={760}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={isLoading}
      forceRender
      okText="Send"
    >
      <Form layout="vertical" form={form} onFinish={onFinish} onFinishFailed={(err) => console.log('err', err)}>
        <FormInput form={form} />
        <SelectSingleFileFormItem form={form} name="thumbnail" />
      </Form>
    </Modal>
  )
})

export default ModalCPNotify
